<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title card__title__border">{{ $t('messages.my_messages') }}</h1>
      <div class="messages-wrapper">
        <div class="d-flex max-height">
          <div class="messages-users d-flex flex-column" :class="{ 'messages-users-hide': !!messages.to }">
            <div class="search-box">
              <b-form-input v-model="users.search" size="sm" class="full-width" type="text" v-bind:placeholder="$t('messages.search')" />
            </div>
            <div class="users-box flex-grow-1">
              <div v-for="user in users.data" :key="'u' + user.user_id" class="user" :class="{ 'bg-primary text-white font-weight-bold': messages.to && messages.to.user_id === user.user_id }" @click="selectUser(user)">
                <div class="d-flex align-items-center">
                  <div class="mr-3"><font-awesome-icon icon="user-circle" size="3x" :class="{ 'red': !messages.to || (messages.to && messages.to.user_id !== user.user_id) }"></font-awesome-icon></div>
                  <div>
                    <div>{{ user.full_name }}</div>
                    <div v-if="user.message" :class="{ 'font-weight-bold': !user.opened_date && user.message_user_id == $store.state.userId }">{{ user.message }}</div>
                  </div>
                </div>
              </div>
              <div v-if="users.data.length === 0" class="p-20">
                <p class="font-italic">{{ $t('messages.messages_users_empty') }}</p>
              </div>
            </div>
          </div>
          <div class="messages-messages d-flex flex-column full-width" v-if="messages.to">
            <div class="d-flex align-items-center messages-to">
              <div class="d-flex align-items-center full-width">
                <div class="mr-3"><b-link :to="{ path: '/user/' + slugText(messages.to.user_id + '-' + messages.to.full_name) }"><font-awesome-icon icon="user-circle" size="3x" class="red"></font-awesome-icon></b-link></div>
                <div><b-link :to="{ path: '/user/' + slugText(messages.to.user_id + '-' + messages.to.full_name) }" class="text-inherit">{{ messages.to.full_name }}</b-link></div>
              </div>
              <div>
                <font-awesome-icon icon="times-circle" size="2x" class="red pointer" @click="clearUser"></font-awesome-icon>
              </div>
            </div>
            <div id="messages-div" class="messages-box flex-grow-1">
              <div v-for="message in messages.data" :key="'m' + message.id" class="mb-2">
                <div v-if="getDate(message)" class="d-table margin-left-auto margin-right-auto mb-2 text-muted small">
                  {{ getDate(message) }}
                </div>
                <div class="d-flex align-items-center">
                  <div class="d-table messages-border p-2" :class="{ 'bg-light': message.user_id_from != $store.state.userId, 'bg-primary text-white margin-left-auto': message.user_id_from == $store.state.userId }">
                    {{ message.message }}
                  </div>
                  <div v-if="message.user_id_from == $store.state.userId" class="ml-2">
                    <font-awesome-icon :icon="message.opened_date ? 'check-circle' : ['far', 'circle']" class="red"></font-awesome-icon>
                  </div>
                </div>
                <div v-if="getTime(message)" class="d-table mt-2 mb-2 text-muted small" :class="{ 'time-ml': message.user_id_from != $store.state.userId, 'margin-left-auto time-mr': message.user_id_from == $store.state.userId }">
                  {{ getTime(message) }}
                </div>
              </div>
            </div>
            <div class="messages-text">
              <b-form @submit.prevent="postMessage">
                <div class="d-flex">
                  <b-form-input ref="text" type="text" v-model="messages.text" required></b-form-input>
                  <notification-button :message="$t('messages.messages_post')" :notification="notifications.message" field="message"
                                       :disabled="!messages.text" class="ml-2"></notification-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationButton from '../components/NotificationButton'
import _ from 'lodash'

import { defaultMixin } from '../mixin/default'
import { notificationMixin } from '../mixin/notification'
import { messageService } from '../services/message.service'
import { userService } from '../services/user.service'

export default {
  name: 'messages',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.my_messages') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.my_messages'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  mixins: [ defaultMixin, notificationMixin ],
  components: { NotificationButton },
  data: function () {
    return {
      users: {
        search: null,
        data: []
      },
      messages: {
        focus: false,
        interval: null,
        to: null,
        text: null,
        data: [],
        dates: []
      },
      notifications: {
        message: null
      }
    }
  },
  methods: {
    getDate: function (message) {
      let fullDate = new Date(message.sent_date.replace(/-/g, '/'))
      let split = this.translateDate(message.sent_date).split(' ')
      let date = this.translateDay(fullDate.getDay()) + ' ' + split[0] + ' ' + split[1] + ' ' + split[2]

      let items = this.messages.dates.filter(function (item) {
        return item.date === date
      })
      if (items.length === 0) {
        this.messages.dates.push({ 'id': message.id, 'date': date })
      }
      let messageItems = this.messages.dates.filter(function (item) {
        return item.date === date && item.id === message.id
      })
      if (messageItems.length > 0) {
        return messageItems[0].date
      } else {
        return ''
      }
    },
    getTime: function (message) {
      let splitTime = message.sent_date.split(' ')[1].split(':')
      let time = splitTime[0] + ':' + splitTime[1]
      return time
    },
    selectUser: function (user) {
      this.fetchMessages(user)
    },
    clearUser: function () {
      this.messages.to = null
      this.messages.data = []
      this.messages.dates = []
      this.messages.text = null
    },
    postMessage: function () {
      let store = this.$store
      messageService.post(this.messages.to.user_id, this.messages.text)
        .then(() => {
          this.sendNotification('message', 'success')
          this.messages.text = null
          this.fetchUsers()
          this.fetchMessages(this.messages.to)
        }, () => {
          store.commit('error', 'errors.message_sent')
          this.sendNotification('message', 'error')
        })
    },
    fetchUsers: function () {
      let store = this.$store

      messageService.fetchUsers(this.users.search)
        .then((users) => {
          this.users.data = users
        }, () => {
          store.commit('error', 'errors.messages')
        })
    },
    fetchMessages: function (user) {
      let store = this.$store

      messageService.get(user.user_id)
        .then((messages) => {
          this.messages.focus = true
          this.messages.to = user
          this.messages.data = messages
          this.messages.dates = []
          messageService.getTotalUnread()
            .then((count) => {
              store.commit('messagesUnread', count)
            }, () => {})
        }, () => {
          store.commit('error', 'errors.messages')
        })
    },
    fetchMessagesInterval: function (user) {
      let store = this.$store

      messageService.get(user.user_id)
        .then((messages) => {
          if (this.messages.to) {
            this.messages.data = messages
            this.messages.dates = []
          }
        }, () => {
          store.commit('error', 'errors.messages')
        })
    },
    removeMessagePuller: function () {
      clearInterval(this.messages.interval)
    }
  },
  watch: {
    'users.search': _.debounce(function () {
      this.fetchUsers()
    }, 1000)
  },
  created: function () {
    let loader = this.$loading.show()
    let store = this.$store

    messageService.fetchUsers(this.users.search)
      .then((users) => {
        this.users.data = users
        if (this.$route.params.id && this.$route.params.id !== this.$store.state.userId) {
          userService.getBasic(this.$route.params.id)
            .then((user) => {
              this.fetchMessages(user)
              loader.hide()
            }, () => {
              store.commit('error', 'errors.user_fetch_different')
              loader.hide()
            })
        } else if (this.users.data.length > 0) {
          this.fetchMessages(this.users.data[0])
          loader.hide()
        } else {
          loader.hide()
        }
      }, () => {
        store.commit('error', 'errors.messages')
        loader.hide()
      })

    this.$root.$on('resetNotification', (notification) => {
      this.resetNotification(notification)
    })
  },
  mounted: function () {
    let self = this
    this.messages.interval = setInterval(function () {
      self.fetchUsers()
      if (self.messages.to) {
        self.fetchMessagesInterval(self.messages.to)
      }
    }, 1000)
  },
  updated: function () {
    let messagesDiv = document.getElementById('messages-div')
    if (messagesDiv) {
      if (this.messages.focus) {
        messagesDiv.scrollTop = messagesDiv.scrollHeight
        this.$refs.text.$el.focus()
        this.messages.focus = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card__wrapper {
  }

  .messages-users {
    width: 100%;
    min-width: 100%;
  }

  .messages-users-hide {
    display: none !important;
  }

  @media screen and (min-width: 768px) {
    .messages-users {
      width: 300px;
      min-width: 300px;
      border-right: 1px #D3D3D3 solid;
    }

    .messages-users-hide {
      display: -webkit-box !important;
      display: -ms-flexbox !important;
      display: flex !important;
    }
  }

  .search-box {
    border-bottom: 1px #D3D3D3 solid;
    padding: 20px;
  }

  .users-box {
    overflow-y: auto;
  }

  .user {
    border-bottom: 1px #D3D3D3 solid;
    padding: 20px;
    cursor: pointer;
  }

  .messages-to {
    padding: 14px;
    border-bottom: 1px #D3D3D3 solid;
    font-weight: bold;
    height: 71.75px;
    min-height: 71.75px;
  }

  .messages-box {
    padding: 20px;
    border-bottom: 1px #D3D3D3 solid;
    overflow-y: auto;
  }

  .messages-border {
    border-radius: 5px;
  }

  .messages-text {
    padding: 20px;
  }

  .margin-left-auto {
    margin-left: auto;
  }

  .margin-right-auto {
    margin-right: auto;
  }

  .max-height {
    min-height: 600px;
    max-height: 600px;
    height: 600px;
  }

  .time-ml {
    margin-left: 8px;
  }

  .time-mr {
    margin-right: 32px;
  }

  .clear {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Messages.vue